import { configureStore } from '@reduxjs/toolkit'
import { systemReducer } from './system'
import { authReducer } from './auth'

export const store = configureStore({
  reducer: {
    system: systemReducer,
    auth: authReducer,
  },
})

export default store
export type RootState = ReturnType<typeof store.getState>
